module.exports = __webpack_public_path__ + "img/warning.456a0ed2.png";